/**
 * Критические методы системы — доступны только ролям admin / root.
 * semiadmin не видит их в дереве прав и не может выдать их другому пользователю.
 * id соответствуют Methods_ID.js (Server_Authorization → Users)
 */
export const CRITICAL_METHODS: string[] = [
  "767be1ed", // registration_tv / registration_tablet — регистрация новых устройств
  "fe568096", // getUsers — список всех пользователей
  "f00429eb", // forceDeleteUserById — полное удаление пользователей
];
